import { Component } from '@angular/core';
import { EventsModule } from '../../../../events/events.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-championship-view-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    EventsModule,
  ],
  templateUrl: './championship-view-dashboard-page.component.html',
})
export class ChampionshipViewDashboardPageComponent { }
